var map = {
	"./Group 22302.png": 1252,
	"./avatar-christmas.webp": 1253,
	"./bottom-bg-christmas.webp": 1254,
	"./btn-active.png": 1255,
	"./content-deco-1.webp": 1256,
	"./content-deco-2.webp": 1257,
	"./content-deco-3.webp": 1258,
	"./content-deco-4.webp": 1259,
	"./deco-3.webp": 1260,
	"./deposit-icon.webp": 1261,
	"./home-icon-active.webp": 1262,
	"./home-icon.webp": 1263,
	"./live-icon-active.webp": 1264,
	"./live-icon.webp": 1265,
	"./master-bg.jpg": 1266,
	"./master-bg.webp": 1267,
	"./me-icon-active.webp": 1268,
	"./me-icon.webp": 1269,
	"./platform.png": 1270,
	"./platform.webp": 1271,
	"./promos-icon-active.webp": 1272,
	"./promos-icon.webp": 1273,
	"./promos.webp": 1274,
	"./service-christmas.webp": 1275,
	"./snowman.webp": 1276,
	"./sponsor-icon-active.webp": 1277,
	"./sponsor-icon.webp": 1278,
	"./title-deco-left.webp": 1279,
	"./title-deco-right.webp": 1280,
	"./tree.webp": 1281,
	"./vip-icon.webp": 1282,
	"./vip.webp": 1283,
	"./withdraw-icon.webp": 1284,
	"./wwr-img.webp": 1285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 107;